
import Enumerable from "linq";
import sanitizeHtml from "sanitize-html";
import { Component, Mixins } from "vue-property-decorator";
import { IButtonConfig } from "../IButtonConfig";
import { IMessages } from "../IMessages";
import { DialogMixin } from "../../mixins";
import { IConfirmDialogOptions, IConfirmableAsynchronously } from "..";

@Component
export default class ConfirmDialogMixin extends Mixins(DialogMixin) implements IConfirmableAsynchronously {
  data(): any {
    return {
      title: null,
      messages: [],
      buttons: [],
      cancelButtonText: null,
      additionalHtmlContent: null,
      result: null as number,
    };
  }
  title: string;
  messages: (string | IMessages)[];
  buttons: IButtonConfig[];
  cancelButtonText: string;
  additionalHtmlContent: string;
  result: number;

  isMessage(source: string | IMessages): boolean {
    return (!source || (typeof source === "string"));
  }

  toMessageClass(source: string | IMessages): string {
    return this.isMessage(source)
      ? "confirm-dialog-message"
      : "confirm-dialog-messages";
  }

  async show(options: IConfirmDialogOptions): Promise<number> {
    // this.$confirmで使うときはフィールド変数ではないところで値を管理しないと値がごちゃまぜになる？
    return this.showModal(async () => {
      this.title = (options && options.title) ? options.title : "確認";
      this.messages = (options && options.message) ? options.message : [];
      this.buttons = (options && options.buttons) ? Enumerable.from(options.buttons).select(b => (typeof b === "string") ? this.toButtonConfig(b) : b).toArray() : [];
      this.cancelButtonText = (options && options.cancellation && options.cancellation.isEnable)
        ? options.cancellation.label
          ? options.cancellation.label
          : "中止する"
        : null;
      this.additionalHtmlContent = !!options.additionalHtmlContent ? options.additionalHtmlContent : null;
      this.result = null;
      await this.waitHidden();
      return this.result;
    });
  }

  get isCancelButtonVisible(): boolean {
    return !!this.cancelButtonText;
  }

  get isAdditionalHtmlContentVisible(): boolean {
    return !!this.additionalHtmlContent;
  }

  get additionalHtmlContentOptions(): sanitizeHtml.IOptions {
    return {
      allowedAttributes: {
        "*": ["style"],
      },
    };
  }

  private toButtonConfig(source: string): IButtonConfig {
    return {
      kind: "confirm",
      label: source,
    };
  }
  
  async confirmYesNo(title: string, message: string[] | IMessages[]): Promise<number> {
    return this.show({
      title: title, 
      message: message,
      buttons: [
        {
          kind: "confirm",
          label: "はい",
        }, 
      ],
      cancellation: {
        isEnable: true,
        label: "いいえ",
      },
    });
  }

  async confirmCancel(title: string, message: string[] | IMessages[], buttonLabel: string): Promise<number> {
    return this.show({
      title: title, 
      message: message,
      buttons: [
        {
          kind: "confirm",
          label: buttonLabel,
        }, 
      ],
      cancellation: {
        isEnable: true,
      },
    });
  }

  async confirmDangerCancel(title: string, message: string[] | IMessages[], buttonLabel: string, cancelLabel?: string, additionalHtmlContent?: string): Promise<number> {
    return this.show({
      title: title, 
      message: message,
      buttons: [
        {
          kind: "danger",
          label: buttonLabel,
        }, 
      ],
      cancellation: {
        isEnable: true,
        label: cancelLabel ? cancelLabel : "",
      },
      additionalHtmlContent: additionalHtmlContent,
    });
  }

  async confirmRegisterCancel(title: string, message: string[] | IMessages[]): Promise<number> {
    return this.confirmCancel(title, message, "登録する");
  }

  async confirmSaveCancel(title: string, message: string[] | IMessages[]): Promise<number> {
    return this.confirmCancel(title, message, "保存する");
  }

  async confirmExecuteCancel(title: string, message: string[] | IMessages[]): Promise<number> {
    return this.confirmCancel(title, message, "実行する");
  }

  async confirmInsertCancel(title: string, message: string[] | IMessages[]): Promise<number> {
    return this.confirmCancel(title, message, "追加する");
  }

  async confirmUpdateCancel(title: string, message: string[] | IMessages[]): Promise<number> {
    return this.confirmCancel(title, message, "更新する");
  }

  async confirmDeleteCancel(title: string, message: string[] | IMessages[]): Promise<number> {
    return this.confirmDangerCancel(title, message, "削除する");
  }

  async confirmDestructCancel(title: string, message: string[] | IMessages[]): Promise<number> {
    return this.confirmDangerCancel(title, message, "破棄する");
  }

  confirmAndClose(index: number): void {
    this.result = index;
    this.isVisible = false;
  }

  cancelAndClose(): void {
    this.result = null;
    this.isVisible = false;
  }
}
